module.exports = __webpack_public_path__ + "static/img/04.c479b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/04.png
// module id = uSdT
// module chunks = 1